import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import CardButton from '@/common/components/cardButton/CardButton';
import MainLayout from '@/common/components/layouts/MainLayout';
import { ADJUSTER_REPORT_CULPRIT_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/culprit/culpritLinks';
import ComplimentImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/complimentImagesIcon.svg?react';
import DamagedImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/damagedImagesIcon.svg?react';
import DocumentImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/documentImagesIcon.svg?react';
import VehicleImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/vehicleImagesIcon.svg?react';
import { getCulpritCustomerImagesTabsOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritCustomerImagesTabs/getCulpritCustomerImagesTabsOptions';
import { AdjusterImageTabType } from '@/modules/adjusterReportModules/IncidentParticipants/types/images';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="مقصر / تصاویر" header="titleHeader">
      <CustomerImagesTabs />
    </MainLayout>
  );
};

const CustomerImagesTabs = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const { data, isPending } = useQuery(
    getCulpritCustomerImagesTabsOptions({
      id: +id!,
    }),
  );

  const renderRoute = (tabName: AdjusterImageTabType['name']) => {
    let tabIcon: Record<AdjusterImageTabType['name'], string> = {
      additional_image: ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_IMAGES({
        id: +id!,
      }).ADJUSTER_ADDITIONAL.edit,
      document_image: ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_IMAGES({
        id: +id!,
      }).ADJUSTER_DOCUMENT.edit,
      vehicle_image: ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_IMAGES({
        id: +id!,
      }).customerVehicle,
      damaged_image: ADJUSTER_REPORT_CULPRIT_LINKS.CULPRIT_IMAGES({
        id: +id!,
      }).customerDocument,
    };
    return tabIcon[tabName];
  };
  const goToFile = (tabName: AdjusterImageTabType['name']) => {
    navigate(renderRoute(tabName));
  };
  return (
    <Box pt="2rem" mt="4rem">
      {isPending ? (
        <Box display="flex" alignItems="center" justifyContent="center">
          <CircularLoading color="colors.purple-primary" />
        </Box>
      ) : (
        <Box
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            position: 'relative',
            top: '-5px',
          })}
        >
          <Box
            className={css({
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
            })}
          >
            <TitleDescription>تصاویر مشتری</TitleDescription>
            <Box>
              {data?.map((item, index) =>
                (item.name === 'vehicle_image' ||
                  item.name === 'damaged_image') &&
                !item.is_card_active ? null : (
                  <CardButton
                    key={item?.name}
                    cardProps={{
                      className: css({
                        marginY: '1rem',
                        marginTop: index === 0 ? '0rem' : '1rem',
                        marginBottom:
                          index === data.length - 1 ? '0rem' : '1rem',
                      }),
                      onClick: () => goToFile(item?.name),
                    }}
                    hasArrow
                    renderIcon={() => renderIcon(item?.name)}
                    title={item?.fa_name}
                  />
                ),
              )}
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

const renderIcon = (tabName: AdjusterImageTabType['name']) => {
  let tabIcon: Record<AdjusterImageTabType['name'], React.JSX.Element> = {
    additional_image: <ComplimentImagesIcon />,
    document_image: <DocumentImagesIcon />,
    vehicle_image: <VehicleImagesIcon />,
    damaged_image: <DamagedImagesIcon />,
  };
  return tabIcon[tabName];
};
